import actions from './actions';
import { createReducer } from '../../../../helpers/reducer';

const initState = {
  invites: null,
  filteredTotal: 0,
  filters: [],
  loading: false,
  total: 0,
};

function onLoad(state) {
  return {
    ...state,
    loading: true,
  };
}

function onLoadSuccess(state, { payload }) {
  const { data, total, filteredTotal, filters, invite } = payload;

  return {
    ...state,
    invites: data.map(item => {
      if (invite?.id === item.id) {
        item.isDateBold = true;
      }

      return item;
    }),
    filteredTotal,
    filters,
    loading: false,
    total,
  };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.CLEAR_STORE]: onClearStore,
});
